import { useEffect, useState } from "react";

const PromilCalculating = ({ finalValue, onComplete }) => {
  const [displayValue, setDisplayValue] = useState(0);
  const [isRevealing, setIsRevealing] = useState(false);
  const [digitAnimation, setDigitAnimation] = useState(true);

  useEffect(() => {
    // Daha uzun ve heyecanlı animasyon
    const duration = 3500; // 3.5 saniye
    const steps = 70;
    const increment = finalValue / steps;
    let currentStep = 0;

    const interval = setInterval(() => {
      currentStep++;
      if (currentStep <= steps) {
        // Random jitter ekle (heyecan için)
        const jitter = (Math.random() - 0.5) * 0.1;
        setDisplayValue((prev) => Math.min(Math.max(0, prev + increment + jitter), finalValue * 1.1));
      } else {
        clearInterval(interval);
        setDisplayValue(finalValue);
        setDigitAnimation(false);
        setIsRevealing(true);
        
        // Reveal animasyonundan sonra sonucu göster
        setTimeout(() => {
          onComplete();
        }, 1200);
      }
    }, duration / steps);

    return () => clearInterval(interval);
  }, [finalValue, onComplete]);

  // Digit animation için split
  const formattedValue = displayValue.toFixed(2);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 backdrop-blur-2xl">
      <div className="text-center space-y-12 px-4">
        {/* Rotating rings around calculator */}
        <div className="relative inline-block">
          {/* Outer spinning ring */}
          <div className="absolute inset-0 animate-spin" style={{ animationDuration: '2s' }}>
            <div className="w-64 h-64 border-[6px] border-transparent border-t-teal-500 border-r-cyan-500 rounded-full opacity-60"></div>
          </div>
          
          {/* Middle spinning ring */}
          <div className="absolute inset-6 animate-spin" style={{ animationDuration: '3s', animationDirection: 'reverse' }}>
            <div className="w-52 h-52 border-[5px] border-transparent border-b-sky-500 border-l-teal-400 rounded-full opacity-50"></div>
          </div>
          
          {/* Inner pulsing ring */}
          <div className="absolute inset-12 animate-pulse" style={{ animationDuration: '1.5s' }}>
            <div className="w-40 h-40 border-[4px] border-teal-500/30 rounded-full"></div>
          </div>
          
          {/* Center content */}
          <div className="relative z-10 w-64 h-64 flex items-center justify-center">
            <div className="text-center">
              <p className="text-xs text-teal-400 font-bold uppercase mb-4 tracking-widest animate-pulse">
                Hesaplanıyor
              </p>
              
              {/* Rolling counter with slot machine effect */}
              <div className="relative h-28 overflow-hidden mb-4">
                <div 
                  className={`text-8xl font-black text-gradient-glow transition-all duration-500 ${
                    isRevealing ? 'scale-110' : 'scale-100'
                  } ${digitAnimation ? 'animate-pulse' : ''}`}
                  style={{
                    filter: isRevealing 
                      ? 'drop-shadow(0 0 40px rgba(20, 184, 166, 1)) drop-shadow(0 0 60px rgba(6, 182, 212, 0.8))' 
                      : 'drop-shadow(0 0 15px rgba(20, 184, 166, 0.6))',
                    transform: digitAnimation ? 'translateY(-2px)' : 'translateY(0)',
                  }}
                >
                  {formattedValue}‰
                </div>
              </div>
              
              {/* Progress bar */}
              <div className="w-48 h-1 bg-gray-800 rounded-full mx-auto overflow-hidden">
                <div 
                  className="h-full bg-gradient-to-r from-teal-500 via-cyan-500 to-sky-500 rounded-full transition-all"
                  style={{
                    width: `${Math.min((displayValue / finalValue) * 100, 100)}%`,
                    transition: 'width 0.1s ease-out'
                  }}
                ></div>
              </div>
            </div>
          </div>
        </div>

        {/* Animated loading text */}
        <div className="space-y-4">
          <div className="flex items-center justify-center space-x-3">
            <div className="w-4 h-4 bg-teal-500 rounded-full animate-bounce shadow-lg" style={{ animationDelay: '0s', boxShadow: '0 0 20px rgba(20, 184, 166, 0.8)' }}></div>
            <div className="w-4 h-4 bg-cyan-500 rounded-full animate-bounce shadow-lg" style={{ animationDelay: '0.15s', boxShadow: '0 0 20px rgba(6, 182, 212, 0.8)' }}></div>
            <div className="w-4 h-4 bg-sky-500 rounded-full animate-bounce shadow-lg" style={{ animationDelay: '0.3s', boxShadow: '0 0 20px rgba(14, 165, 233, 0.8)' }}></div>
          </div>

          <p className="text-teal-400 text-lg font-bold animate-pulse">
            Widmark formülü uygulanıyor...
          </p>
        </div>
      </div>
    </div>
  );
};

export default PromilCalculating;
